import React from 'react';
import { styled } from 'styled-components';
import { Svg } from '../../_atoms/Svg';

const MaskWrap = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
`;

export const Mask = () => {
  return (
    <MaskWrap>
      <Svg />
    </MaskWrap>
  );
};